module.exports = __webpack_public_path__ + "static/media/vip_2.144c0fc3.svg";